<section class="navigation-section section-padding">
	<div class="navs">
		<button class="button {{cancelBtnType}}" (click)="cancel.emit()">
			{{cancelBtnText}}
		</button>
		<div>
			<button class="button primary" aria-label="next" (click)="next.emit()" data-cy="checkoutBtn">
				{{ nextBtnText }}
			</button>
		</div>
	</div>
</section>
